import React, { useEffect, useState } from "react";
import { Card, Col, Container, Modal, Row, Spinner } from "react-bootstrap";
import { FFmpeg } from "@ffmpeg/ffmpeg";
import { fetchFile } from "@ffmpeg/util";
import { useSelector } from "react-redux";
import axios from "axios";
import { MdTranscribe } from "react-icons/md";
import { PulseLoader } from "react-spinners";
import CustomButton from "../../ui/custom-button";
import { toast } from "react-toastify";

const ffmpeg = new FFmpeg({ log: true });
const convertToMono = async (blob) => {
  try {
    await ffmpeg.load();
    await ffmpeg.writeFile("input.wav", await fetchFile(blob));
    await ffmpeg.exec(["-i", "input.wav", "-ac", "1", "output.wav"]);
    const data = await ffmpeg.readFile("output.wav");
    const monoBlob = new Blob([data.buffer], { type: "audio/wav" });
    // //console.log(monoBlob);
    return monoBlob;
  } catch (err) {
    //console.log(err);
    return new Blob();
  }
};

function AudioUplaod() {
  const [isLoading, setisLoading] = useState(false);
  const user = useSelector((state) => state?.userInfo?.user);
  const [audiofiledata, setAudiofileData] = useState([]);
  //console.log("audiofiledata", audiofiledata);
  const [transcipt, setTranscript] = useState("");
  const [uploadedfile, setUploadedFile] = useState([]);
  const [saving, setSaving] = useState(false);

  const handleAudioUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const monoBlob = await convertToMono(file);
    const audioURL = URL.createObjectURL(monoBlob);

    setisLoading(true);

    try {
      const formData = new FormData();
      setUploadedFile(monoBlob);
      formData.append("file", monoBlob, "uploaded_audio.wav");
      formData.append("user_id", user?.id);

      const response = await axios.post(
        `https://us2.sourcesoftsolutions.com:8032/lecture_analysis`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      //console.log("response", response);
      const result = response.data;
      //console.log("result", result);
      setAudiofileData(result?.lecture_analysis);
      setTranscript(result?.transcript);
      // Optionally set transcript too
    } catch (error) {
      console.error("Error uploading audio:", error);
    } finally {
      setisLoading(false);
    }
  };

  // const handleSave = async () => {
  //   try {
  //     const payload = {};
  //   } catch (error) {
  //     //console.log("error", error);
  //   }
  // };

  const handleSave = async () => {
    setSaving(true);
    const formData = new FormData();
    formData.append("audio_file", uploadedfile, "recording.wav");
    // formData.append("user_id", user?.id);
    formData.append("analysis", JSON.stringify(audiofiledata));
    // formData.append("refined_transcript", JSON.stringify(result?.refined_transcript));
    formData.append("transcript", transcipt);
    // formData.append("dob", dob);
    // formData.append("patient_name", patient_name);
    // if (!user) return;

    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/lecture-analyses`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer test123securetoken`,
          },
        }
      );
      toast.success("Audio data saved successfully!");
    } catch (error) {
      console.error("Error saving audio data:", error);
      // toast.error(error?.message || "Something went wrong");
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      {" "}
      <div className="d-flex flex-column">
        <section className="py-2">
          <Container>
            <Row className="justify-content-center">
              <Col md={12}>
                <Card className="mb-4 shadow-sm">
                  <Card.Body className="text-center">
                    <Card.Title className="fw-semibold mb-3">
                      Upload Audio File
                    </Card.Title>
                    <Card.Text className="text-muted">
                      Click the button to upload audio file
                    </Card.Text>
                    {isLoading ? (
                      <label
                        htmlFor="upload-audio"
                        className="btn btn-outline-primary"
                      >
                        <PulseLoader color="blue" />
                      </label>
                    ) : (
                      <>
                        <label
                          htmlFor="upload-audio"
                          className="btn btn-outline-primary"
                        >
                          Select Audio File
                        </label>
                        <input
                          id="upload-audio"
                          type="file"
                          accept="audio/*"
                          className="d-none"
                          onChange={handleAudioUpload}
                        />
                      </>
                    )}
                  </Card.Body>

                  {transcipt ? (
                    <div className="mt-3">
                      <div className="conversation-card">
                        <div
                          className={`conversation-placeholder d-flex align-items-center my-1 justify-content-center text-secondary`}
                        >
                          <span className="mx-2">
                            <MdTranscribe />
                          </span>
                          Your transcribe will be shown here
                        </div>
                      </div>
                      {transcipt && (
                        <>
                          <div
                            className={`d-flex align-items-center my-4 justify-content-center`}
                          >
                            <div>
                              <span className="text-muted">{transcipt}</span>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  ) : (
                    <></>
                  )}
                </Card>
              </Col>

              {audiofiledata && audiofiledata.length !== 0 && (
                <div className="mt-5">
                  <div className="card">
                    <div className="card-header">
                      <h3 className="card-title">Lecture Information</h3>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-12 my-3">
                          <h5 className="card-subtitle mb-1 text-muted">
                            Rating Key Concepts
                          </h5>
                          <p className="card-text">
                            {audiofiledata["Rating Key Concepts"] ||
                              "Information not provided"}
                          </p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12 my-3">
                          <h5 className="card-subtitle mb-1 text-muted">
                            Rating Lecture Quality
                          </h5>
                          <p className="card-text">
                            {audiofiledata["Rating Lecture Quality"] ||
                              "Information not provided"}
                          </p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12 my-3">
                          <h5 className="card-subtitle mb-1 text-muted">
                            Rating Professor Tone and Style
                          </h5>
                          <p className="card-text">
                            {audiofiledata["Rating Professor Tone and Style"] ||
                              "Information not provided"}
                          </p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12 my-3">
                          <h5 className="card-subtitle mb-1 text-muted">
                            Rating Questions Asked
                          </h5>
                          <p className="card-text">
                            {audiofiledata["Rating Questions Asked"] || 0}
                          </p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12 my-3">
                          <h5 className="card-subtitle mb-1 text-muted">
                            Rating Student Interaction
                          </h5>
                          <p className="card-text">
                            {audiofiledata["Rating Student Interaction"] || 0}
                          </p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12 my-3">
                          <h5 className="card-subtitle mb-1 text-muted">
                            Lecture Quality
                          </h5>
                          <p className="card-text">
                            {audiofiledata["Lecture Quality"] ||
                              "Information not provided"}
                          </p>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-12 my-3">
                          <h5 className="card-subtitle mb-1 text-muted">
                            Engagement Level
                          </h5>
                          <p className="card-text">
                            {audiofiledata["Engagement Level"] ||
                              "Information not provided"}
                          </p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12 my-3">
                          <h5 className="card-subtitle mb-1 text-muted">
                            Pace of Lecture
                          </h5>
                          <p className="card-text">
                            {audiofiledata["Pace of Lecture"] ||
                              "Information not provided"}
                          </p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12 my-3">
                          <h5 className="card-subtitle mb-1 text-muted">
                            Student Interaction
                          </h5>
                          <p className="card-text">
                            {audiofiledata["Student Interaction"] ||
                              "Information not provided"}
                          </p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12 my-3">
                          <h5 className="card-subtitle mb-1 text-muted">
                            Professor Tone and Style
                          </h5>
                          <p className="card-text">
                            {audiofiledata["Professor Tone and Style"] ||
                              "Information not provided"}
                          </p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12 my-3">
                          <h5 className="card-subtitle mb-1 text-muted">
                            Key Concepts
                          </h5>
                          <p className="card-text">
                            {audiofiledata["Key Concepts"]?.length
                              ? audiofiledata["Key Concepts"]?.map(
                                  (ehr) => ehr + ", "
                                )
                              : "Information not provided"}
                          </p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12 my-3">
                          <h5 className="card-subtitle mb-1 text-muted">
                            Questions Asked
                          </h5>
                          <p className="card-text">
                            {audiofiledata["Questions Asked"] ||
                              "Information not provided"}
                          </p>
                        </div>
                      </div>
                      {/* <div className="row">
                        <div className="col-md-6 my-3">
                          <h5 className="card-subtitle mb-1 text-muted">Next Appointment</h5>
                          <p className="card-text">
                            {ehrInfo["Next_Appointment"] || "Information not provided"}
                          </p>
                        </div>
                        <div className="col-md-6 my-3">
                          <h5 className="card-subtitle mb-1 text-muted">Patient History</h5>
                          <p className="card-text">
                            {ehrInfo["Patient_History"] || "Information not provided"}
                          </p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6 my-3">
                          <h5 className="card-subtitle mb-1 text-muted">Vitals</h5>
                          <p className="card-text">
                            {ehrInfo["Vitals"] || "Information not provided"}
                          </p>
                        </div>
                        <div className="col-md-6 my-3">
                          <h5 className="card-subtitle mb-1 text-muted">Symptoms</h5>
                          <p className="card-text">
                            {ehrInfo["Symptoms"] || "Information not provided"}
                          </p>
                        </div>
                      </div> */}
                      <div className="row">
                        <div className="col-md-12 my-3">
                          <h5 className="card-subtitle mb-1 text-muted">
                            Summary
                          </h5>
                          <p className="card-text">
                            {audiofiledata["Summary"] ||
                              "Information not provided"}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </Row>
            {audiofiledata && audiofiledata.length !== 0 && (
              <CustomButton onClick={handleSave}>
                {saving ? "Saving..." : "Save"}
              </CustomButton>
            )}
          </Container>
        </section>
      </div>
    </>
  );
}

export default AudioUplaod;
